import { StyledLinkSectionButton, StyledButton } from './styled';
import { LinkSectionButtonT } from '@components/Molecules/LinkSectionButton/types';

export const LinkSectionButton = ({ display, label, sectionId }: LinkSectionButtonT) => {
  if (!display) return null;

  return (
    <StyledLinkSectionButton>
      <StyledButton href={`#${sectionId}`}>{label}</StyledButton>
    </StyledLinkSectionButton>
  );
};

export default LinkSectionButton;
